/**
 * Removes custome props not supported by DataGrid component.
 * Some props are interpreted differently. By keeping them the custom behavior will
 * be overwritten.
 * @param  {Object} props               Datagrid props
 * @return {Object}       subset of Datagrid props
 */
interface DataGridCustomProps {
  showQuickFilter?: boolean;
  slotClasses?: unknown;
  clickableRow?: boolean;
  [key: string]: unknown;
}

export const normalizeProps = (
  props: DataGridCustomProps,
): DataGridCustomProps => {
  const normalProps = { ...props };

  delete normalProps["showQuickFilter"];
  delete normalProps["slotClasses"];
  delete normalProps["clickableRow"];
  delete normalProps["slots"]; // Toolbar is rendered outside DataGrid

  return normalProps;
};

/**
 * Creates a map with the classes to assign to each row
 * @param  {Object} props               Datagrid props
 * @return {Map}       Map of css classes
 */
export const getRowClasses = (
  props: DataGridCustomProps,
): Map<number, string> => {
  if (props.clickableRow) {
    return new Map([
      [0, "even clickable"],
      [1, "odd clickable"],
    ]);
  }

  return new Map([
    [0, "even"],
    [1, "odd"],
  ]);
};

/**
 * Calculates the best getRowId function for the dataset
 * @param  {Object} record               a record from a dataset
 * @return {function}        getRowId function
 */
export const calcRowIdFn = (
  record: Record<string, unknown> | undefined,
): ((row: Record<string, unknown>) => unknown) => {
  let fn = (row: Record<string, unknown>) => row["__rowId"];
  if (record) {
    if (record["id"] != null) {
      fn = (row) => row["id"];
    }
  }

  return fn;
};
